///本地缓存类
const localCache = {
    setString(key, value) {
        localStorage.setItem(key, value)
    },
    getString(key) {
        return localStorage.getItem(key)
    },
    setObject(key, value) {
        localStorage.setItem(key, JSON.stringify(value))
    },
    getObject(key) {
        return JSON.parse(localStorage.getItem(key))
    },
    removeItem(key) {
        localStorage.removeItem(key)
    }
}
export default localCache